import React from 'react';

import { useRouter } from 'next/router';

import Icon from '~/src/common/components/Icon';
import { useShouldDisplayWidthThreshold } from '~/src/common/hooks/useDom';
import I18n from '~/src/common/services/I18n/I18n';
import { GetMarketingBySlugQuery } from '~/src/queries/cms/generated/cms';
import InfoContent from '~/src/screens/InfoScreen/InfoContent';
import * as S from '~/src/screens/InfoScreen/layout';
import { breakpoints } from '~/src/styles-constants';

interface Props {
  slug: string;
  info: NonNullable<NonNullable<GetMarketingBySlugQuery['modaleMarketings']>[number]>;
}

const InfoScreen = ({ slug, info }: Props) => {
  const { push } = useRouter();
  const isMobileScreen = !useShouldDisplayWidthThreshold(breakpoints.XL);

  const onClickClose = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises  -- auto-ignored when updating eslint
    push('/');
  };

  return (
    <S.Container>
      {isMobileScreen ? (
        <S.MobileCloseButton
          icon="cross"
          onClick={onClickClose}
          iconSize={36}
          label={I18n.t('common.close')}
        />
      ) : (
        <S.GoBackLink href="/" style={{ display: 'flex' }}>
          <Icon name="Arrow-back" size={16} />
          <S.GoBackSpan>{I18n.t('common.back')}</S.GoBackSpan>
        </S.GoBackLink>
      )}
      <InfoContent slug={slug} source="page" info={info} />
    </S.Container>
  );
};

export default InfoScreen;
